<h2 mat-dialog-title>You have unsaved changes</h2>
<mat-dialog-content>
  All your changes will be lost. Do you want to continue?
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>No</button>
  <button mat-button [mat-dialog-close]="true" color="warn">Yes</button>
</mat-dialog-actions>
